import React, {useState, useEffect, useContext} from "react";
import {TestCard} from "../../components/global/VideoCard";
import {TestContext} from "../../context/test_context";
import {
    Avatar,
    Badge,
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    Icon,
    IconButton,
    Input,
    Pagination,
    Stack,
    TextField,
    Typography,
    debounce,
    alpha,
    Button,
} from "@mui/material";
import "../tests/styles.css";
import useAuth from "../../hooks/auth_hook";
import {useNavigate} from "react-router-dom";
import LoadBox from "../../components/global/LoadBox";
import moment from "moment";
import {ArrowBack, Close, Refresh} from "@mui/icons-material";
import TestButtonSet from "../../components/test/TestButtonSet";
import {TestList, TestPageContext} from "../tests";

export default function FinishedTests(): any {
    const [reload, setReload] = useState(false)

    return (
        <TestPageContext.Provider value={{reload, setReload}}>
            <Box
                sx={{
                    width: "100%",
                    display: {xs: "block", md: "flex"},
                    justifyContent: "center",
                    marginX: 5,
                    flexDirection: "row",
                    pt: 2,
                    maxheight: "100%",
                }}
            >
                <TestList finished={true} active={false} title={"Finished Tests"}/>
            </Box>
        </TestPageContext.Provider>
    );
}
